import { connect } from "react-redux";
import { fetchAccountData } from "../../../../../../actions/globalActions";
import EditTIFF from "../../Components/EditTIFF";
import {
  setExchangeIntoTiff,
  setStepOne,
  selectTiffOption,
  setStepTwo,
  submitTiffForm, 
  getTiffFormInfo,
  getTiffDisclaimer,
  fetchPoolData,
  fetchUnderlyingFunds,
  setPoolModalFalse,
  resetFlow,
  getTiffData,
  submitUpdateTiff,
  updateFromAmount,
  getAllPools,
  getExpectedExchangeDate,
  getPoolsInfo,
  editMode,
  fetchAllPoolDataFrom,
  submitFormData,
  fetchAccountDataTiff
} from "./actions";
import {
  switchTabExchange,
  setPathFromTIFF,
} from "../../../RecommendFlow/actions";
import history from "../../../../../../history/history";

const mapStateToProps = state => ({
  availableBalance: state.getIn(["globalState", "availableBalance"]),
  currentBalance: state.getIn(["globalState", "currentBalance"]),
  accDataLoading: state.getIn(["tiffExchange", "accountData", "isLoading"]),
  accDataPools: state.getIn(["tiffExchange", "accountData", "data"]),
  allPoolLoading: state.getIn(["tiffExchange", "toFrom", "isLoading"]),
  allPoolData: state.getIn(["tiffExchange", "toFrom", "data"]),
  
  inputValues: state.getIn(["tiffExchange", "fromPool", "data"]),
  inputValuesLoading: state.getIn(["tiffExchange", "fromPool", "isLoading"]),
  tiffExchangeAmount: state.getIn(["tiffExchange", "tiffExchangeAmount"]),
  poolTableInto: state.getIn(["tiffExchange", "stepOne"]),
  stepOneSet: state.getIn(["tiffExchange", "stepOneSet"]),
  poolTableFrom: state.getIn(["tiffExchange", "stepTwo"]),
  stepTwoSet: state.getIn(["tiffExchange", "stepTwoSet"]),
  selectedTiffOption: state.getIn(["tiffExchange", "selectTiffOption"]),
  tiifInfoData: state.getIn(["tiffExchange", "tiffInfo", "data"]),
  tiifInfoLoading: state.getIn(["tiffExchange", "tiffInfo", "isLoading"]),
  tiffDisclaimer:state.getIn(["tiffExchange","tiffDisclaimer"]),
  tiffPoolName:state.getIn(["tiffExchange","tiffPoolName"]),
  poolData: state.getIn(["recommendAnExchange", "poolData", "singlePool"]),
  poolUf: state.getIn(["recommendAnExchange", "poolData", "singleUF"]),
  poolModal: state.getIn(["recommendAnExchange", "poolData", "modalPool"]),
  modalUF: state.getIn(["recommendAnExchange", "poolData", "modalUF"]),
  isDisabled: state.getIn(["tiffExchange", "isDisabled"]),
  getTiffDetails: state.getIn(["tiffExchange","viewEditTiff","data","singleExchange"]),
  intoTotal: state.getIn(["tiffExchange", "intoTotal"]),
  exchangeAmount: state.getIn(["tiffExchange", "exchangeAmount"]),
  expectedEchangeDate: state.getIn([
    "tiffExchange",
    "expectedEchangeDate",
    "data"
  ]),
  expectedEchangeDateLoader: state.getIn([
    "tiffExchange",
    "expectedEchangeDate",
    "isLoading"
  ]),
  fromTiffPoolDetails: state.getIn(["tiffExchange", "fromTiffPoolDetails"]),
  toTiffPoolDetails: state.getIn(["tiffExchange", "toTiffPoolDetails"]),
  allPoolFromLoading: state.getIn(["tiffExchange", "toFrom", "isLoading"]),
  allPoolFromData: state.getIn(["tiffExchange", "toFrom", "data"]),
  accDataFromLoading: state.getIn([
    "tiffExchange",
    "accountData",
    "isLoading",
  ]),
  accDataFromPools: state.getIn(["tiffExchange", "accountData", "data"]),
});

export const mapDispatchToProps = dispatch => ({
  requestData: data => dispatch(fetchAccountData(data)),
  tabExchange: (key) => {
    dispatch(switchTabExchange(key));
    dispatch(setPathFromTIFF());
    if (key !== "tiff") {
      history.push({
        pathname: "/recommendAnExchange/recommendAnExchangeFrom",
      });
    }
  },
  setExchangeIntoTiff: data => dispatch(setExchangeIntoTiff(data)),
  setStepOne: data => dispatch(setStepOne(data)),
  setStepTwo: data => dispatch(setStepTwo(data)),
  selectTiffOption: data => dispatch(selectTiffOption(data)),
  submitTiffForm: data => dispatch(submitTiffForm(data)),
  getTiffFormInfo: data => dispatch(getTiffFormInfo(data)),
  getTiffDisclaimer:data => dispatch(getTiffDisclaimer(data)),
  requestPoolData: data => dispatch(fetchPoolData(data)),
  requestunderlyingFunds: data => dispatch(fetchUnderlyingFunds(data)),
  setPoolModalFalse: data => dispatch(setPoolModalFalse(data)),
  
  getData: data => dispatch(getTiffData(data)),
  resetFlow: () => dispatch(resetFlow()),
  submitUpdateTiff: data => dispatch(submitUpdateTiff(data)),
  updateFromAmount: data => dispatch(updateFromAmount(data)),
  getAllPools: data => dispatch(getAllPools(data)),
  getPoolsInfo: data => dispatch(getPoolsInfo(data)),
  editMode: data => dispatch(editMode(data)),

  requestAllPoolDataTiff: data => dispatch(fetchAllPoolDataFrom(data)),
  requestDataTiff: data => dispatch(fetchAccountDataTiff(data)),
  getExchangeDate: data => dispatch(getExpectedExchangeDate(data)),
  submitData: data => dispatch(submitFormData(data))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EditTIFF);
